<template>
  <nav>
    <div class="navbar navbar-light bg-white">
      <div class="container">
        <!-- First row: Menu button and logo -->
        <div class="mobile-first-row">
          <v-layout v-if="celular">
            <v-app-bar-nav-icon
              variant="text"
              @click="drawerMobile = !drawerMobile"
            ></v-app-bar-nav-icon>
          </v-layout>

          <div class="d-flex align-items-center logo-wrapper">
            <router-link :to="produtosLink" class="logo-container">
              <div class="logo-circle">
                <img
                  :src="empresarodape.url_logo"
                  alt="logo"
                  class="logo-image"
                />
              </div>
            </router-link>
          </div>
        </div>

        <!-- Second row: Search -->
        <form class="d-flex align-items-center search-container" role="search">
          <div class="search-wrapper">
            <input
              type="search"
              v-model.trim="buscador"
              class="form-control search-input"
              placeholder="Buscar produtos..."
              aria-label="Search"
            />
            <router-link
              :to="buscaLink"
              v-slot="{ href, navigate }"
              :class="{ disabled: this.buscador == '' }"
            >
              <button
                :href="href"
                @click="
                  carregarBusca();
                  navigate();
                "
                class="search-button"
                type="submit"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  class="bi bi-search"
                  viewBox="0 0 16 16"
                >
                  <path
                    d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"
                  ></path>
                </svg>
              </button>
            </router-link>
          </div>
        </form>

        <!-- Third row: Action icons and login -->
        <div class="mobile-third-row">
          <div class="contact-container">
            <div
              class="contact-dropdown"
              @click="toggleContactDropdown"
              @mouseenter="showContactDropdown"
              @mouseleave="hideContactDropdown"
            >
              <div class="contact-trigger">
                <span class="contact-label">Nosso Contato</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  class="bi bi-telephone"
                  viewBox="0 0 16 16"
                >
                  <path
                    d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.6 17.6 0 0 0 4.168 6.608 17.6 17.6 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.68.68 0 0 0-.58-.122l-2.19.547a1.75 1.75 0 0 1-1.657-.459L5.482 8.062a1.75 1.75 0 0 1-.46-1.657l.548-2.19a.68.68 0 0 0-.122-.58zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877z"
                  />
                </svg>
              </div>
              <div
                class="contact-dropdown-content"
                :class="{ show: isDropdownVisible }"
              >
                <div class="contact-item" v-if="empresarodape.telefone">
                  <span class="contact-type">Telefone:</span>
                  <span class="contact-value">{{
                    empresarodape.telefone
                  }}</span>
                </div>
                <div class="contact-item" v-if="empresarodape.whatsappcontato">
                  <span class="contact-type">WhatsApp:</span>
                  <span class="contact-value">{{
                    empresarodape.whatsappcontato
                  }}</span>
                </div>
                <div class="contact-item" v-if="empresarodape.email">
                  <span class="contact-type">E-mail:</span>
                  <span class="contact-value">{{ empresarodape.email }}</span>
                </div>
              </div>
            </div>
          </div>
          <router-link :to="barcodeLink">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="60"
              height="32"
              fill="currentColor"
              class="bi bi-upc-scan"
              viewBox="0 0 16 16"
            >
              <path
                d="M1.5 1a.5.5 0 0 0-.5.5v3a.5.5 0 0 1-1 0v-3A1.5 1.5 0 0 1 1.5 0h3a.5.5 0 0 1 0 1h-3zM11 .5a.5.5 0 0 1 .5-.5h3A1.5 1.5 0 0 1 16 1.5v3a.5.5 0 0 1-1 0v-3a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 1-.5-.5zM.5 11a.5.5 0 0 1 .5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 1 0 1h-3A1.5 1.5 0 0 1 0 14.5v-3a.5.5 0 0 1 .5-.5zm15 0a.5.5 0 0 1 .5.5v3a1.5 1.5 0 0 1-1.5 1.5h-3a.5.5 0 0 1 0-1h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 1 .5-.5zM3 4.5a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0v-7zm2 0a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0v-7zm2 0a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0v-7zm2 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-7zm3 0a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0v-7z"
              />
            </svg>
          </router-link>
          <router-link :to="carrinhosLink"
            ><img
              src="../../../public/shopping-cart.png"
              alt="logo"
              width="30"
            />
            <base-badge mode="elegant"
              >{{ carrinhoQuantidade }}
            </base-badge></router-link
          >
          <router-link
            :to="minhaConta"
            id="meuspedidos"
            v-if="this.usuarioLogado == true"
            class="d-flex flex-nowrap align-items-center"
            ><svg
              xmlns="http://www.w3.org/2000/svg"
              width="32"
              height="32"
              fill="currentColor"
              class="bi bi-person-fill"
              viewBox="0 0 16 16"
            >
              <path
                d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"
              />
            </svg>
            <p>Olá, {{ nomeBoasVindas }}!</p>
          </router-link>
          <router-link
            :to="minhaConta"
            id="meuspedidos"
            v-if="this.usuarioLogado == false"
            ><button>Faça seu Login</button>
          </router-link>
        </div>
      </div>
    </div>

    <v-row
      v-if="!celular && !hasPermanentSide"
      class="justify-start align-start category-row"
      style="background-color: #434c5a; padding: 20px"
    >
      <div class="category-container">
        <!-- Todos (hamburger) button that opens the left vertical menu -->
        <div class="todos-wrapper" v-if="!hasPermanentSide">
          <button
            class="todos-btn"
            @click="toggleSideMenu"
            aria-label="Abrir menu de categorias"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              fill="currentColor"
              class="bi bi-list"
              viewBox="0 0 16 16"
            >
              <path
                fill-rule="evenodd"
                d="M2.5 12.5a.5.5 0 010-1h11a.5.5 0 010 1h-11zm0-4a.5.5 0 010-1h11a.5.5 0 010 1h-11zm0-4a.5.5 0 010-1h11a.5.5 0 010 1h-11z"
              />
            </svg>
            <span class="todos-label">Todos</span>
          </button>
        </div>
        <item-categoria-novo
          v-for="item in visibleCategories"
          :key="item.codigoCategoria"
          :codigo="item.codigoCategoria"
          :item="item.categoria"
          :filhas="item.filhas"
          text-color="white"
        >
        </item-categoria-novo>
      </div>
    </v-row>

    <v-navigation-drawer
      v-if="!hasPermanentSide"
      v-model="drawerMobile"
      :width="320"
      temporary
      app
      right
    >
      <div class="mobile-drawer-header">
        <h4>Categorias</h4>
        <button
          class="side-close"
          @click="drawerMobile = false"
          aria-label="Fechar"
        >
          ×
        </button>
      </div>
      <div class="side-menu-content">
        <item-categoria-side
          v-for="item in categoria"
          :key="item.codigoCategoria"
          :codigo="item.codigoCategoria"
          :item="item.categoria"
          :filhas="item.filhas"
          class="side-item"
          text-color="black"
        ></item-categoria-side>
      </div>
    </v-navigation-drawer>

    <!-- Left side menu (vertical) -->
    <div
      v-if="!hasPermanentSide"
      :class="['side-menu-overlay', { open: showSideMenu }]"
      @click="closeSideMenu"
    ></div>
    <aside
      v-if="!hasPermanentSide"
      :class="['side-menu', { open: showSideMenu }]"
      role="dialog"
      aria-modal="true"
      aria-label="Menu de categorias"
    >
      <div class="side-menu-header">
        <h3>Categorias</h3>
        <button
          class="side-close"
          @click="closeSideMenu"
          aria-label="Fechar menu"
        >
          ×
        </button>
      </div>
      <div class="side-menu-content">
        <item-categoria-side
          v-for="item in categoria"
          :key="item.codigoCategoria"
          :codigo="item.codigoCategoria"
          :item="item.categoria"
          :filhas="item.filhas"
          class="side-item"
          text-color="black"
        ></item-categoria-side>
      </div>
    </aside>
  </nav>
</template>

<script>
import ItemCategoriaNovo from "../produtos/ItemCategoriaNovo.vue";
import ItemCategoriaSide from "../produtos/ItemCategoriaSide.vue";
import { mapState } from "vuex";

export default {
  components: {
    ItemCategoriaNovo,
    ItemCategoriaSide,
  },
  data() {
    return {
      // drawer (global) removed; mobile drawer moved into header
      celular: false,
      buscador: "",
      maxVisibleCategories: 6, // Adjust this number based on your layout
      isDropdownVisible: false,
      showSideMenu: false,
      drawerMobile: false,
    };
  },
  computed: {
    ...mapState("empresa", ["empresarodape"]),
    ...mapState("login", ["usuarioLogado"]),
    ...mapState("login", ["dadosCliente"]),
    ...mapState("produtos", ["categoria"]),
    // Whether the app should render a permanent side menu (App.vue handles it)
    hasPermanentSide() {
      // only treat as permanent when the empresa flag is set AND we are not on a mobile layout
      return (
        this.empresarodape &&
        this.empresarodape.menu_categorias === "V" &&
        this.celular === false
      );
    },
    loja() {
      return this.$store.getters["loja/lojaSelecionada"];
    },
    mediaQuery() {
      return window.matchMedia("(max-width: 1279px)");
    },
    nomeBoasVindas() {
      return this.dadosCliente.nome.split(" ")[0];
    },
    tipo() {
      return this.$store.getters["loja/tipoSelecionado"];
    },
    carrinhoQuantidade() {
      return this.$store.getters["carrinhos/quantidade"];
    },
    produtosLink() {
      return "/" + this.tipo + "/" + this.loja + "/produtos";
    },
    carrinhosLink() {
      return "/" + this.tipo + "/" + this.loja + "/carrinho";
    },
    minhaConta() {
      return "/" + this.tipo + "/" + this.loja + "/produtos/minhaconta";
    },
    buscaLink() {
      return (
        "/" + this.tipo + "/" + this.loja + "/produtos/busca/" + this.buscador
      );
    },
    barcodeLink() {
      return "/" + this.tipo + "/" + this.loja + "/barcode";
    },
    categorianumber() {
      return this.$store.getters["loja/categoriaSelecionada"];
    },
    visibleCategories() {
      return this.categoria.slice(0, this.maxVisibleCategories);
    },
    hiddenCategories() {
      return this.categoria.slice(this.maxVisibleCategories);
    },
    hasMoreCategories() {
      return this.hiddenCategories.length > 0;
    },
  },
  methods: {
    async carregarBusca() {
      await this.$store.dispatch("produtos/carregarBusca", {
        busca: this.buscador,
      });
      this.buscador = "";
    },
    async carregarCategorias() {
      await this.$store.dispatch("produtos/carregarCategorias");
    },
    handleResize() {
      if (this.mediaQuery.matches) {
        this.drawer = false;
        this.celular = true;
      } else {
        this.drawer = true;
        this.celular = false;
      }
    },
    toggleContactDropdown() {
      this.isDropdownVisible = !this.isDropdownVisible;
    },
    showContactDropdown() {
      this.isDropdownVisible = true;
    },
    hideContactDropdown() {
      this.isDropdownVisible = false;
    },
    toggleSideMenu() {
      // only allow toggling the header's side menu when there's no permanent side
      if (this.hasPermanentSide) return;
      this.showSideMenu = !this.showSideMenu;
      // prevent background scrolling when menu open
      document.body.style.overflow = this.showSideMenu ? "hidden" : "";
    },
    closeSideMenu() {
      this.showSideMenu = false;
      document.body.style.overflow = "";
    },
    onKeyDown(e) {
      if (e.key === "Escape" && this.showSideMenu) {
        this.closeSideMenu();
      }
    },
  },
  watch: {
    async categorianumber(newCategory, oldCategory) {
      if (newCategory != oldCategory) {
        this.$store.dispatch("produtos/isProdutoLoading");

        await this.$store.dispatch("loja/resetPaginacao");
        await this.$store.dispatch("produtos/resetProdutos");
        await this.$store.dispatch("produtos/carregarCategoriaSelecionada", {
          ordem: "LAN%C3%87AMENTO",
        });

        this.$store.dispatch("produtos/isProdutoReady");
      }
    },
  },
  created() {
    this.carregarCategorias();
    window.addEventListener("resize", this.handleResize);
    window.addEventListener("keydown", this.onKeyDown);
    this.handleResize();
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.handleResize);
    window.removeEventListener("keydown", this.onKeyDown);
  },
};
</script>

<style scoped>
@import "@/styles/variables.css";

.form-control:focus {
  border-color: var(--primary-color);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px #13433a;
}

.search-container {
  margin: 0 20px;
}

.search-wrapper {
  display: flex;
  align-items: center;
  background: white;
  border-radius: 30px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  transition: all 0.3s ease;
}

.search-wrapper:focus-within {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.search-input {
  border: none;
  padding: 10px 20px;
  width: 300px;
  outline: none;
  font-size: 14px;
}

.search-input:focus {
  box-shadow: none;
}

.search-button {
  background: transparent;
  border: none;
  color: var(--primary-color);
  padding: 10px 20px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.search-button:hover {
  color: #13433a;
}

.search-button:disabled {
  color: #ccc;
  cursor: not-allowed;
}

@media (max-width: 768px) {
  .container {
    padding: 0 15px;
    display: flex;
    flex-direction: column;
    gap: 15px;
  }

  .mobile-first-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 0;
    width: 100%;
  }

  .search-container {
    width: 100%;
    margin: 0;
  }

  .search-wrapper {
    width: 100%;
  }

  .search-input {
    width: 100%;
  }

  .mobile-third-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 10px 0;
    gap: 15px;
  }

  .logo-circle {
    width: 80px;
    height: 80px;
  }

  .logo-image {
    width: 60px;
  }

  .v-app-bar-nav-icon {
    margin-right: 0;
  }

  .contact-label {
    display: none;
  }
}

@media (min-width: 1400px) {
  .mobile-third-row {
    display: flex;
    align-items: center;
    gap: 20px;
    padding: 0;
  }
}

.disabled {
  opacity: 0.5;
  pointer-events: none;
}

form > a {
  padding: 0;
  margin: 0;
}

ul {
  list-style: none;
  margin: 0;
  padding: 0;
  justify-self: center;
  align-items: center;
  font-size: 40px;
  justify-content: space-between;
}

li {
  font-size: 15px;
  list-style: none;
  margin: 0 1rem;
}

#meuspedidos {
  color: #13433a;
}

#meuspedidos:active,
#meuspedidos:hover,
#meuspedidos.router-link-active {
  color: var(--primary-color);
}

a {
  text-decoration: none;
  color: rgb(0, 0, 0);
  font-weight: bold;
  border-bottom: 2px solid transparent;
  width: max-content;
}

a:hover,
a:active,
a.router-link-active {
  color: #32424a;
}

button {
  font: inherit;
  cursor: pointer;
  padding: 0.5rem 1.5rem;
  border: 1px solid var(--primary-color);
  background-color: transparent;
  color: var(--primary-color);
  border-radius: 30px;
}

button:hover,
button:active {
  background-color: var(--primary-color);
  color: white;
}

p {
  color: black;
  margin: 0;
}

.logo-wrapper {
  position: relative;
  z-index: 2;
}

.logo-container {
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  transition: transform 0.3s ease;
}

.logo-container:hover {
  transform: scale(1.05);
  text-decoration: none;
}

.logo-container:focus {
  text-decoration: none;
}

.logo-container:active {
  text-decoration: none;
}

.logo-circle {
  width: 200px;
  height: 200px;
  border-radius: 50%;
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  transition: all 0.3s ease;
}

.logo-circle:hover {
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
}

.logo-image {
  width: 160px;
  height: auto;
  object-fit: contain;
  transition: transform 0.3s ease;
}

.logo-circle:hover .logo-image {
  transform: scale(1.05);
}

.category-row {
  position: relative;
  z-index: 1;
  margin-top: -30px;
  padding-left: 220px !important; /* Space for the logo */
}

.category-container {
  margin-left: 80px;
  display: flex;
  align-items: center;
  gap: 20px;
  flex-wrap: nowrap;
  overflow-x: hidden;
}

.more-categories {
  margin-left: auto;
}

.more-categories-btn {
  background: transparent;
  border: none;
  color: white;
  font-weight: bold;
  cursor: pointer;
  padding: 8px 16px;
  border-radius: 4px;
  transition: background-color 0.3s ease;
}

.more-categories-btn:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.dropdown-item {
  padding: 8px 16px;
  white-space: nowrap;
}

/* Ensure categories don't wrap */
.item-categoria-novo {
  white-space: nowrap;
}

.custom-scroll {
  max-height: 450px;
  overflow-y: auto;
}

.custom-scroll::-webkit-scrollbar-track {
  background: #f0f0f0;
}

.custom-scroll::-webkit-scrollbar-thumb {
  background-color: var(--primary-color);
  border-radius: 4px;
  border: 2px solid #f0f0f0;
}

/* For Firefox */
.custom-scroll {
  scrollbar-color: var(--primary-color) #f0f0f0;
  scrollbar-width: thin;
}

.whatsapp-icon {
  display: flex;
  align-items: center;
  transition: transform 0.3s ease;
  color: #25d366;
  position: relative;
}

.whatsapp-icon:hover {
  transform: scale(1.1);
}

.whatsapp-icon:hover::after {
  content: attr(title);
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  padding: 5px 10px;
  background-color: #25d366;
  color: white;
  border-radius: 4px;
  font-size: 14px;
  white-space: nowrap;
  z-index: 1;
}

.whatsapp-icon svg {
  width: 32px;
  height: 32px;
}

/* Todos (hamburger) button */
.todos-wrapper {
  display: flex;
  align-items: center;
  margin-right: 12px;
}
.todos-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  background: transparent;
  border: none;
  color: white;
  font-weight: 600;
  cursor: pointer;
  padding: 8px 12px;
  border-radius: 6px;
}
.todos-btn:hover {
  background: rgba(255, 255, 255, 0.06);
}
.todos-label {
  display: inline-block;
  font-size: 14px;
}

/* Side menu overlay */
.side-menu-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.25s ease, visibility 0.25s ease;
  z-index: 1000;
}
.side-menu-overlay.open {
  opacity: 1;
  visibility: visible;
}

/* Side menu */
.side-menu {
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 320px;
  max-width: 90vw;
  background: #fff;
  transform: translateX(-110%);
  transition: transform 0.28s ease;
  z-index: 1001;
  display: flex;
  flex-direction: column;
  box-shadow: 4px 0 24px rgba(0, 0, 0, 0.12);
}
.side-menu.open {
  transform: translateX(0);
}
.side-menu-header {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 1px solid #eee;
  position: relative;
}
.side-menu-header h3 {
  flex: 1 1 auto;
  text-align: center;
  margin: 0;
}
.side-close {
  margin-left: auto;
  background: transparent;
  border: none;
  font-size: 28px;
  line-height: 1;
  cursor: pointer;
}
.side-menu-content {
  padding: 12px 8px;
  overflow-y: auto;
}
.side-item {
  padding: 6px 12px;
  border-radius: 4px;
}

/* Mobile drawer header: same alignment as side-menu-header */
.mobile-drawer-header {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 1px solid #eee;
  position: relative;
}
.mobile-drawer-header h4 {
  flex: 1 1 auto;
  text-align: center;
  margin: 0;
  font-size: 1.05rem;
}
.mobile-drawer-header .side-close {
  margin-left: auto;
  background: transparent;
  border: none;
  font-size: 28px;
  line-height: 1;
  cursor: pointer;
}

@media (max-width: 1279px) {
  /* On mobile we keep the existing drawer behavior; hide the Todos in the wide category row */
  .todos-wrapper {
    display: none;
  }
}

.contact-container {
  display: flex;
  align-items: center;
}

.contact-dropdown {
  position: relative;
  display: inline-block;
  cursor: pointer;
}

.contact-trigger {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  padding: 8px 12px;
  border-radius: 4px;
  transition: background-color 0.3s ease;
}

.contact-trigger:hover {
  background-color: rgba(19, 67, 58, 0.1);
}

.contact-label {
  font-size: 14px;
  color: #13433a;
  font-weight: 500;
}

.contact-dropdown-content {
  display: none;
  position: absolute;
  left: 0;
  background-color: white;
  min-width: 300px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  padding: 16px;
  z-index: 1001;
  transition: opacity 0.3s ease, transform 0.3s ease;
  opacity: 0;
  transform: translateY(-10px);
}

.contact-dropdown-content.show {
  display: block;
  opacity: 1;
  transform: translateY(0);
}

.contact-item {
  margin-bottom: 12px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.contact-item:last-child {
  margin-bottom: 0;
}

.contact-type {
  font-weight: 600;
  color: #13433a;
  font-size: 14px;
}

.contact-value {
  color: #666;
  font-size: 14px;
  line-height: 1.4;
}

@media (max-width: 768px) {
  .contact-label {
    display: none;
  }

  .contact-dropdown-content {
    min-width: 280px;
    left: 0;
    top: 100%;
    margin-top: 8px;
  }

  .contact-trigger {
    padding: 8px;
  }

  .mobile-third-row {
    position: relative;
    z-index: 1002;
  }
}
</style>
